import { render, staticRenderFns } from "./PaySlipTeacher.vue?vue&type=template&id=0c723e76&scoped=true"
import script from "./PaySlipTeacher.vue?vue&type=script&lang=js"
export * from "./PaySlipTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c723e76",
  null
  
)

export default component.exports